import { HRISProviderSlugEnum } from '@electricjs/core_entity-client';
import { TFunction } from 'i18next';

const PARTNER_PROVIDERS = {
  [HRISProviderSlugEnum.AdpWfn]: 'ADP',
  [HRISProviderSlugEnum.AdpWfnTotalSource]: 'ADP',
  [HRISProviderSlugEnum.AdpWfnCanada]: 'ADP',
  [HRISProviderSlugEnum.AdpR]: 'ADP RUN',
  [HRISProviderSlugEnum.Justworks]: 'JUSTWORKS',
  [HRISProviderSlugEnum.TrinetHrPlatform]: 'TRINET',
  [HRISProviderSlugEnum.Justworksdirect]: 'JUSTWORKS',
};

export const getIsProviderConnected = (
  needsUpgrade: boolean | undefined,
  providerSlug: string | undefined,
  cardSlug: HRISProviderSlugEnum | HRISProviderSlugEnum[] | undefined
) => {
  if (needsUpgrade || !providerSlug) {
    return false;
  }
  // Return true if:
  // The provider is connected and matches the current card's slug(s).
  // The card does not have a slug and the provider is not among the displayed providers.
  if (cardSlug) {
    const slugsToCheck = Array.isArray(cardSlug) ? cardSlug : [cardSlug];
    return slugsToCheck.includes(providerSlug as HRISProviderSlugEnum);
  }
  return !Object.keys(PARTNER_PROVIDERS).includes(providerSlug);
};

export const getCustomStatusLabel = (
  isConnected: boolean,
  currentProviderSlug: string | undefined,
  currentProviderName: string | undefined,
  t: TFunction
) => {
  return isConnected &&
    currentProviderSlug &&
    currentProviderName &&
    !Object.keys(PARTNER_PROVIDERS).includes(currentProviderSlug)
    ? t(
        'applications:integrations.integrationCard.statusConnectedWithProvider',
        {
          providerName: currentProviderName,
        }
      )
    : '';
};
